let Test = require('@/mixins/Forms/2022/NRCA_LTI_04_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            functional_test: {
                name: `B. Functional Testing using Current Measurement (NA7.6.3.2, Method 2)`,
                steps: {
                    step_1: {
                        id:`1`,
                        name: `At the lighting circuit panel, select at least one lighting control circuit that serves spaces required to meet Section 110.12`,
                        code_reference:`NA7.6.3.2.2, Method 2(a)`,
                        rows: {}
                    },
                    step_2: {
                        id:`2`,
                        name: `<b>Full output test</b>`,
                        code_reference:`NA7.6.3.2.2, Method 2(b)`,
                        rows: {
                            row_1: {
                                id: `2.1`,
                                type: 'Text',
                                text: `Using the manual switches/dimmers, set the lighting system to full output in the space served by the selected circuit. The lighting in areas with photo controls or occupant/vacancy sensors may be at less than full output or may be off.`,
                                code_reference:`NA7.6.3.2.2, Method 2(b)1`,
                            },
                            row_2: {
                                id: `2.2`,
                                type: 'Float',
                                question: `Measure the current at the selected circuit and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.2, Method 2(b)2`,
                                circuits: []
                            },
                            row_3: {
                                id: `2.3`,
                                type: 'StringResult',
                                question: `Calculate the sum of all the circuit currents in the full output condition and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.2, Method 2(b)5`,
                                answer: '',
                                merge_cells: true,
                            },
                            row_4: {
                                id: `2.4`,
                                type: 'Text',
                                text: `Simulate a demand response condition using the demand responsive control in the space served by the selected circuit.`,
                                code_reference:`NA7.6.3.2.2, Method 2(b)3`,
                            },
                            row_5: {
                                id: `2.5`,
                                type: 'Float',
                                question: `Measure the current at the selected circuit with the electric lighting system in the demand response condition and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.2, Method 2(b)4`,
                                circuits: []
                            },
                            row_6: {
                                id: `2.6`,
                                type: 'StringResult',
                                question: `Calculate the sum of all the circuit currents in the demand response condition and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.2, Method 2(b)5`,
                                answer: '',
                                merge_cells: true,
                            },
                            row_7: {
                                id: `2.7`,
                                type: 'Percentage',
                                question: `Calculate the percent reduction in current at the selected circuit from the full output condition to the demand response condition and enter the value in %. Percent reduction = [(Step 2.2 - Step 2.5) / Step 2.2] x 100% `,
                                code_reference:null,
                                circuits: []
                            },
                            row_8: {
                                id: `2.8`,
                                type: 'Percentage',
                                question: `Calculate the total percent reduction in current from the full output condition to the demand response condition and enter the value in %. Total percent reduction = [(Step 2.3 - Step 2.6) / Step 2.3] x 100% `,
                                code_reference:`NA7.6.3.2, Method 2(b)5`,
                                answer: '',
                                merge_cells: true,
                            },
                            row_9: {
                                id: `2.9`,
                                type: 'BooleanResult',
                                question: `The total percent reduction in current (Step 2.8) is at least 15%.`,
                                code_reference:`NA7.6.3.2.2, Method 2(b)5`,
                                circuits: [],
                            },
                        }
                    },
                    step_3: {
                        id:`3`,
                        name: `Step 3: Minimum output test`,
                        code_reference:`NA7.6.3.2.2, Method 2(c)`,
                        rows: {
                            row_1: {
                                id: `3.1`,
                                type: 'Text',
                                text: `Using the manual switches/dimmers in each space, set the lighting system to minimum output (but not off) in the space served by the selected circuit. The lighting in areas with photo controls or occupant/vacancy sensors may be at more than minimum output or may be off.`,
                                code_reference:`NA7.6.3.2.2, Method 2(c)1`,
                            },
                            row_2: {
                                id: `3.2`,
                                type: 'Float',
                                question: `Measure the current at the selected circuit and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.2, Method 2(c)2`,
                                circuits: []
                            },
                            row_3: {
                                id: `3.3`,
                                type: 'Text',
                                text: `Simulate a demand response condition using the demand responsive control in the space served by the selected circuit.`,
                                code_reference:`NA7.6.3.2.2, Method 2(c)3`,
                            },
                            row_4: {
                                id: `3.4`,
                                type: 'Float',
                                question: `Measure the current at the selected circuit with the electric lighting system in the demand response condition and enter the value in amperes (A).`,
                                code_reference:`NA7.6.3.2.2, Method 2(c)4`,
                                circuits: []
                            },
                            row_5: {
                                id: `3.5`,
                                type: 'BooleanResult',
                                question: `The current in the demand respond condition (Step 3.4) is not less than the current in the minimum output condition (Step 3.2).(Step 3.4 >= Step 3.2) (NA7.6.3.2.2, Method 2(c)5).<br><small>Exception: Circuits that supply power to the daylit portion of enclosed spaces as long as the current for lighting in the non-daylit portions of the enclosed space in the demand response condition is not reduced below the current in the minimum light output condition.</small>`,
                                code_reference:`NA7.6.3.2.2, Method 2(c)5 EXCEPTION`,
                                circuits: []
                            },
                        }
                    },
                },
                result: false,
                comments: '',
                circuits: [],
            },
        }
    },

    mounted() {
        if (this.data == null) {
            this.addCircuit();
        }
    },

    methods: {

        functionalTestEvaluation() {

            this.form.functional_test.result = true;

            var steps = this.form.functional_test.steps;

            var s1Questions = steps.step_1.rows;
            var s2Questions = steps.step_2.rows;
            var s3Questions = steps.step_3.rows;

            // Row C => 2.3
            var row_2_3 = 0;
            _.each(this.form.functional_test.circuits, (circuit, index) => {
                row_2_3 += s2Questions.row_2.circuits[index].answer;
            });
            s2Questions.row_3.answer = row_2_3.toFixed(2);

            // Row F =>2.6
            var row_2_6 = 0;
            _.each(this.form.functional_test.circuits, (circuit, index) => {
                row_2_6 += s2Questions.row_5.circuits[index].answer;
            });
            s2Questions.row_6.answer = row_2_6.toFixed(2);

            _.each(this.form.functional_test.circuits, (circuit, index) => {

                // Line G => 2.7 = (Porcent reduction = [(line B=>2.2 - line E =>2.5) / line B =>2.2] x 100%)
                var row_2_2 = s2Questions.row_2.circuits[index].answer;
                var row_2_5 = s2Questions.row_5.circuits[index].answer;
                var row_2_7 = ((row_2_2 - row_2_5) / row_2_2);
                s2Questions.row_7.circuits[index].answer = this.isValidNumber(row_2_7) ? row_2_7 : 0;

                // Line H => 2.8 = (Total percent reduction = [(line c - line f) / line c] x 100%)
                // var row_2_6 = s2Questions.row_6.answer;
                var row_2_8 = ((row_2_3 - row_2_6) / row_2_3);
                s2Questions.row_8.answer = this.isValidNumber(row_2_8) ? row_2_8 : 0;

                // Line I => 2.9
                var row_2_9 = s2Questions.row_9.circuits[index].answer = (row_2_8 >= .15)

                // Line O
                var row_3_4 = s3Questions.row_2.circuits[index].answer;
                var row_3_5 = s3Questions.row_4.circuits[index].answer;

                // 50% of Line B => 2.2
                var _50PercentOfRow2_2 = (.5 * row_2_2)

                // Changes made by Mario Martinez
                var resultOne = (row_3_4 < _50PercentOfRow2_2 && row_3_5 < row_3_4);
                var resultTwo = (row_3_4 >= _50PercentOfRow2_2 && row_3_5 < _50PercentOfRow2_2);
                var resultThree = (row_3_5 <= row_2_2);
                var resultFour = (row_3_4 > 0);

                var row_O = s3Questions.row_5.circuits[index].answer = (!resultOne && !resultTwo && resultThree && resultFour);

                if (row_2_9 == false || row_O == false) {
                    this.form.functional_test.result = false;
                }

            })
        },

        loadFormData() {
            if (!this.data) return;

            _.each(this.data.construction_inspection.rows, (question, i) => {
                this.form.construction_inspection.rows[i].answer = question.answer;
            })

            _.each(this.data.functional_test.circuits, circuit => {
                this.updateQuestionCircuits(circuit);
            })

            _.each(this.data.functional_test.steps, (step, i) => {
                _.each(step.rows, (question, j) => {
                    _.each(this.data.functional_test.circuits, (circuit, k) => {
                        if (!this.isText(this.form.functional_test.steps[i].rows[j])) {
                            if (question.hasOwnProperty('merge_cells')) {
                                this.form.functional_test.steps[i].rows[j].answer = question.answer;
                            } else {
                                this.form.functional_test.steps[i].rows[j].circuits[k].answer = question.circuits[k].answer
                            }
                        }
                    })
                })
            })

            this.form.comments = this.data.comments;
        },

        removeCircuit() {
            if (this.canRemoveCircuit) {
                var circuit = this.form.functional_test.circuits[this.form.functional_test.circuits.length - 1];
                Alert.confirmation(`All data from the Circuit ${circuit.name} will be removed.<br>Do you want to continue?`).then(response => {
                    this.form.functional_test.circuits.pop();
                    this.removeCircuitFromQuestions();
                }).catch(() => {
                })
            }
        },

        removeCircuitFromQuestions() {
            _.each(this.form.functional_test.steps, step => {
                _.each(step.rows, question => {
                    if (!this.isText(question)) {
                        question.circuits.pop()
                    }
                })
            })
        },

        addCircuit() {
            this.updateQuestionCircuits({
                id: (this.form.functional_test.circuits.length + 1),
                name: `#${this.form.functional_test.circuits.length + 1}`
            });
        },

        updateQuestionCircuits(circuit) {
            this.form.functional_test.circuits.push(circuit);
            _.each(this.form.functional_test.steps, step => {
                _.each(step.rows, question => {
                    if (question.hasOwnProperty('merge_cells')) {
                        question.answer = this.getDefaultValueForDinamicQuestion(question);
                    } else if (question.type != 'Text') {
                        question.circuits.push({
                            id: circuit.id,
                            name: circuit.name,
                            answer: this.getDefaultValueForDinamicQuestion(question),
                        });
                    }
                })
            })
        },
    },

    computed: {

        rowColspan() {
            return this.form.functional_test.circuits.length;
        },

        canRemoveCircuit() {
            return this.testIsReady ? (this.form.functional_test.circuits.length > 1) : false;
        },
    }
}
